import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

var _table;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import moraga from 'typography-theme-moraga';
import { toTheme } from '@theme-ui/typography';
import { merge } from 'lodash/fp';
import * as modes from './modes';
import prism from './prism';
moraga.headerWeight = 700;
var typography = toTheme(moraga);
export default merge(typography, {
  prism: prism,
  initialColorMode: 'light',
  colors: _objectSpread({}, modes.light, {
    modes: {
      dark: modes.dark
    }
  }),
  fonts: {
    monospace: 'Inconsolata'
  },
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64],
  fontWeights: {
    body: 400,
    heading: 700,
    bold: 700
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125
  },
  letterSpacings: {
    body: 'normal',
    caps: '0.2em'
  },
  space: [0, 4, 8, 16, 32, 48, 64, 80, 100],
  radii: {
    square: 0,
    radius: 4,
    rounded: 10
  },
  styles: {
    Container: {
      p: 4,
      maxWidth: 1280
    },
    root: {
      fontSize: 3,
      color: 'text',
      bg: 'background'
    },
    a: {
      color: 'primary',
      textDecoration: 'none',
      '&:hover': {
        color: 'secondary',
        textDecoration: 'underline'
      }
    },
    h1: {
      fontSize: 6
    },
    h2: {
      fontSize: 5
    },
    h3: {
      fontSize: 4
    },
    h4: {
      fontSize: 3
    },
    h5: {
      fontSize: 2
    },
    h6: {
      fontSize: 1
    },
    li: {
      marginBottom: 1
    },
    blockquote: {
      my: 4,
      mx: 0,
      py: 3,
      px: 4,
      bg: 'blockquote.bg',
      borderLeft: function borderLeft(t) {
        return "5px solid " + t.colors.blockquote.boder;
      },
      color: 'blockquote.color',
      fontStyle: 'italic',
      '> p': {
        m: 0
      }
    },
    code: {
      fontFamily: 'monospace'
    },
    inlineCode: {
      fontFamily: 'monospace'
    },
    pre: {
      my: 4,
      p: 3,
      variant: 'prism',
      textAlign: 'left',
      fontFamily: 'monospace',
      borderRadius: 'radius'
    },
    table: (_table = {
      width: '100%',
      my: 4,
      borderCollapse: 'separate',
      borderSpacing: 0
    }, _table[['th', 'td']] = {
      textAlign: 'left',
      py: '4px',
      pr: '4px',
      pl: 0,
      borderColor: 'muted',
      borderBottomStyle: 'solid'
    }, _table),
    th: {
      verticalAlign: 'bottom',
      borderBottomWidth: '2px'
    },
    td: {
      verticalAlign: 'top',
      borderBottomWidth: '1px'
    },
    hr: {
      border: 0,
      borderBottom: function borderBottom(t) {
        return "1px solid " + t.colors.border;
      }
    }
  }
});